import React from "react";
import { useNavigate } from "react-router-dom";
import { RoutesPaths } from "../Router/Constant";
import { useTranslation } from "react-i18next";

export default function Notfound() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const gotoHomePage = () => {
    navigate(`${RoutesPaths.LANDING}`);
  };
  return (
    <div className="container-fluid maxContainerSection mainHeaderPadding">
      <div className="row">
        <div className="col-md-12">
          <div className="errorSectionMain commonPadding">
            <img src="/assets/img/404Icon.svg" alt="" className="img-fluid" />
            <h3 className="m-0 h3Class">404 – {t("page_not_found")}</h3>
            <p className="m-0 peraClass">
              {t("page_not_found_desc")}
            </p>
            <button className="backtoHome" onClick={gotoHomePage}>
              {t("Back_to_home")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
